import {default as Group, Controller as GroupController} from './../../../zviz2/zviz/components/group';
import TextBox from './../../../zviz2/zviz/components/svg/textbox';
import Rectangle from './../../../zviz2/zviz/components/rectangle';


import state from './../../../zviz2/zviz/state';

import {styleText} from './../../../styles';
import {extend} from './../../../zviz2/zviz/functions';

class Controller extends GroupController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);
    
        this.height = 0;
        this.rowHeights = [];
        this.cols = 2;

    }

    init(renderer){

        super.init(renderer);
        this.rowHeights = [];
    }

    setRowHeight(row, height){
        if(height != this.rowHeights[row]){
            this.rowHeights[row] = (! this.rowHeights[row])? 22: Math.max(this.rowHeights[row], height+7);
            this.height = 0;
            for(let r = 0; r < this.rowHeights.length; r++){
                this.height += this.rowHeights[r];
            }
            this.trigger('legendHeight', [this.height]);
            this.update();
        }

    }

    
    getChildren(){

        let result = [];

        this.cols = (this.data.width >= 300)? 2: 1;

        let count = this.data.values.length;
        let m = Math.ceil(count/this.cols);
        let top = 0;
        for(let i = 0; i < count; i++){
            let c = Math.floor(i/m);
            let r = i - (c*m);
            let v = count - i - 1;
            if(r == 0){
                top = 0;
            }else{
                top += (r==0)? 0: this.rowHeights[r-1];
            }
            let label = this.data.values[v].x || 'unknown';
            let perc = 0;
            if((this.data.values[v].y && this.data.total)){
                perc = Math.round(100 * this.data.values[v].y / this.data.total);
                if(perc == 0){
                    perc = (100 * this.data.values[v].y / this.data.total).toFixed(1);
                    if(perc == '0.0'){
                        perc = (100 * this.data.values[v].y / this.data.total).toFixed(2);
                    }
                }
            }

            label += ' ' + perc + '%';
            result.push(extend({
                properties: {
                    data: {
                        x: c * (this.data.width/this.cols),
                        width: (this.data.width/this.cols),
                        y: top,
                        label: label,
                        color: this.data.values[v].color,
                        row: r
                    },
                }
            }, LegendLine));
            
            this.rowHeights[r] = (! this.rowHeights[r])? 22: Math.max(this.rowHeights[r], 22);
        }

        return result;

    }

}


let LegendLine = extend({
    properties: {
        data: {
            x: 0,
            width: 150,
            y: 0,
            label: 'unknown',
            color: [50,50,50],
            row: 0
        },
        transform: {
            position: {
                x: (ctrl) => (ctrl.data.x),
                y: (ctrl) => (ctrl.data.y)
            }
        },
    },
    children: [
        (parent) => (extend({
            properties: {
                style: {
                    fill: 'rgb(' + parent.data.color.join(',') + ')',
                },
                attributes: {
                    x: 8,
                    y: 10,
                    width: 15,
                    height: 15
                }
            }  
        }, Rectangle) ),

        (parent) => (extend({
            properties: {
                style: extend({
                    fontSize: '15px',
                    fill: '#444'
                 }, styleText),
                transform: {
                    position: {
                        x: 30,
                        y: 22
                    }
                },
                data: {
                    width: parent.data.width-30,
                    text: parent.data.label,
                    alignment: 'left',
                    height: 60,
                    lineHeight: 16
                }
            },
            responders: [
                {name: 'textHeight', callback: [parent.parent, parent.parent.setRowHeight, parent.data.row] },
            ]
        }, TextBox) )
    ]
}, Group);


let Blueprint = extend({
    type: Controller,
    properties: {
        data: {
            values: [],
            width: 300,
            total: 0
        }
    },
    children: [
        (ctrl) => ( ctrl.getChildren() )
    ]
}, Group);

export default Blueprint;